module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'gqpp697s',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
